import type { User } from "@/components/Editor/types";
import { createId } from "@paralleldrive/cuid2";
import { ADJECTIVES, ANIMALS } from "./dictionaries";

const CURSOR_COLORS = [
	"#ef4444",
	"#f97316",
	"#eab308",
	"#84cc16",
	"#14b8a6",
	"#3b82f6",
	"#8b5cf6",
	"#f43f5e",
];

export const getRandomUserInfo = (): User => {
	const adjective = ADJECTIVES[
		Math.floor(Math.random() * ADJECTIVES.length)
	] as string;
	const animal = ANIMALS[Math.floor(Math.random() * ANIMALS.length)] as string;

	// The arrays are not empty, so these will never be undefined
	const capitalizedAdjective =
		adjective.charAt(0).toUpperCase() + adjective.slice(1);
	const capitalizedAnimal = animal.charAt(0).toUpperCase() + animal.slice(1);

	return {
		id: createId(),
		name: `${capitalizedAdjective} ${capitalizedAnimal}`,
		color: CURSOR_COLORS[
			Math.floor(Math.random() * CURSOR_COLORS.length)
		] as string,
	};
};
